import React from 'react';
import { StatCards } from './StatCards';
import WalletIcon from '../../assets/icons/wallet-icon';
import SmartPhoneIcon from '../../assets/icons/smart-phone-icon';
import CoinIcon from '../../assets/icons/coin-icon';
import { currencyFormat } from '../../utils/helper';
import { Row, Col, Card } from 'antd';

function OverviewComponent({ state, analysis, tierData }) {
  const systemStatisticsList = [
    {
      icon: <WalletIcon />,
      title: 'Total Transactions',
      value: { value: analysis?.totalTransactions ?? 0 },
      id: 1,
    },
    {
      icon: <WalletIcon />,
      title: 'Successful Transactions',
      value: { value: analysis?.successfulTransactions ?? 0 },
      id: 2,
    },
    {
      icon: <WalletIcon />,
      title: 'Pending Transactions',
      value: { value: analysis?.pendingTransactions ?? 0 },
      id: 3,
    },
    {
      icon: <WalletIcon />,
      title: 'Failed Transactions',
      value: { value: analysis?.failedTransactions ?? 0 },
      id: 4,
    },
  ];

  const renderTierStatsList = (stats) => [
    { icon: <WalletIcon />, title: 'Tier 1', value: { value: `${stats?.tier1 ?? 0} (${currencyFormat(stats?.tier1Amount ?? 0)})` }, id: 1 },
    { icon: <WalletIcon />, title: 'Tier 2', value: { value: `${stats?.tier2 ?? 0} (${currencyFormat(stats?.tier2Amount ?? 0)})` }, id: 2 },
    { icon: <WalletIcon />, title: 'Tier 3', value: { value: `${stats?.tier3 ?? 0} (${currencyFormat(stats?.tier3Amount ?? 0)})` }, id: 3 },
    { icon: <WalletIcon />, title: 'Tier 4', value: { value: `${stats?.tier4 ?? 0} (${currencyFormat(stats?.tier4Amount ?? 0)})` }, id: 4 },
    { icon: <CoinIcon />, title: 'Total', value: { value: `${stats?.total ?? 0} (${currencyFormat(stats?.totalAmount ?? 0)})` }, id: 5 },
  ];

  return (
    <>
      <div style={{ marginBottom: 10, borderRadius: 10 }}>
        <StatCards lists={systemStatisticsList} state={state} title='System Transaction Overview' />
      </div>
      {tierData && (
        <>
          <div style={{ marginBottom: 10, borderRadius: 10 }}>
            <StatCards lists={renderTierStatsList(tierData.personal)} state={state} title='Personal Accounts Tier Analysis' />
          </div>
          <div style={{ marginBottom: 10, borderRadius: 10 }}>
            <StatCards lists={renderTierStatsList(tierData.nonCac)} state={state} title='Non-CAC Business Tier Analysis' />
          </div>
          <div style={{ marginBottom: 10, borderRadius: 10 }}>
            <StatCards lists={renderTierStatsList(tierData.cac)} state={state} title='CAC Business Tier Analysis' />
          </div>
          <div style={{ marginBottom: 10, borderRadius: 10 }}>
            <Card title="Overall Cumulative Summary">
              <Row gutter={16} key="overall-summary">
                <Col span={12} style={{ textAlign: 'center' }}>
                  <p style={{ margin: 0, fontSize: 12, color: '#BDBDBD' }}>Total Accounts</p>
                  <h4 style={{ margin: 0 }}>{tierData.total}</h4>
                </Col>
                <Col span={12} style={{ textAlign: 'center' }}>
                  <p style={{ margin: 0, fontSize: 12, color: '#BDBDBD' }}>Total Amount</p>
                  <h4 style={{ margin: 0 }}>{currencyFormat(tierData.totalAmount)}</h4>
                </Col>
              </Row>
            </Card>
          </div>
        </>
      )}
    </>
  );
}

export default OverviewComponent;